type SchemaOption = {
  value: string;
};

export const resolveSchemaId = (
  currentSchemaId: string | undefined,
  schemaOptions: SchemaOption[],
): string | undefined => {
  if (schemaOptions.some((option) => option.value === currentSchemaId)) {
    return currentSchemaId;
  }

  return schemaOptions.length === 1 ? schemaOptions[0].value : undefined;
};
